import React from 'react';
import { Schema } from './Schema';
export var SchemaItems = function (_a) {
    var _b;
    var schema = _a.schema;
    if (!schema) {
        return null;
    }
    var type = schema.type();
    if (!(type === null || type === void 0 ? void 0 : type.includes('array'))) {
        return null;
    }
    var items = schema.items();
    if (items &&
        !Array.isArray(items) &&
        Object.keys((_b = items.properties()) !== null && _b !== void 0 ? _b : {}).length) {
        return React.createElement(Schema, { schema: items, isArray: true });
    }
    else if (Array.isArray(items)) {
        return (React.createElement(React.Fragment, null, items.map(function (item, idx) { return (React.createElement(Schema, { schema: item, isArray: true, schemaName: "".concat(idx + 1, " item:"), key: idx })); })));
    }
    return React.createElement(Schema, { schema: items, isArray: true, schemaName: "Items:" });
};
//# sourceMappingURL=SchemaItems.js.map